import { render, staticRenderFns } from "./crear-editar.vue?vue&type=template&id=9e28e908&scoped=true"
import script from "./crear-editar.vue?vue&type=script&lang=js"
export * from "./crear-editar.vue?vue&type=script&lang=js"
import style0 from "./crear-editar.vue?vue&type=style&index=0&id=9e28e908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e28e908",
  null
  
)

export default component.exports